import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { ConfigurationService } from '../ConfigurationService';

export enum DetailedDesktopStatus {
	TileEnabled = 'true',
}

export class DetailedDesktopAccessor {
	private workspaceConfiguration: WorkspaceConfiguration;
	private configurationService: ConfigurationService;

	public constructor(
		workspaceConfiguration: WorkspaceConfiguration,
		configurationService: ConfigurationService
	) {
		this.workspaceConfiguration = workspaceConfiguration;
		this.configurationService = configurationService;
	}

	public isDetailedDesktopTileEnabled(): boolean {
		return (
			this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
				FeatureFlag.ForceDetailedDesktopView
			) ||
			(this.configurationService.featureCanaryConfiguration.isFeatureEnabled(
				FeatureFlag.DetailedDesktopView
			) &&
				this.workspaceConfiguration?.userInterface?.detailedDesktop?.tileEnabled?.toLowerCase() ===
					DetailedDesktopStatus.TileEnabled)
		);
	}
}
